// extracted by mini-css-extract-plugin
module.exports = {"logo":"FullLogoWhiteIcon_logo__qNI45","logo__hat":"FullLogoWhiteIcon_logo__hat__2Lli0"};